import React from "react";
import SimpleContent from "./Content/SimpleContent";
import BioContent from "./Content/BioContent";

import "./TileSelection.css";

const TileSection: React.FC<TileSection> = ({
  type,
  isImgLeft,
  imgSrc,
  content,
  moreInfoSrc,
}) => {
  const hasImage = !!imgSrc;

  return (
    <div className="tileSection">
      <div
        className={`flexContainer ${!isImgLeft ? "reverse" : ""} ${!hasImage ? "noImage" : ""}`}
      >
        {/* IMAGE (only if exists) */}
        {hasImage && (
          <div className="column">
            {type == 2 ? (
              <div className="background">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  controls
                  className="video"
                >
                  <source src={imgSrc ?? ""} type="video/mp4" />
                </video>
              </div>
            ) : (
              <div className="imgBackground">
                <img
                  loading="lazy"
                  src={imgSrc ?? ""}
                  className="image"
                  alt={content.title}
                />
              </div>
            )}
          </div>
        )}

        {/* TEXT (ALWAYS SHOW) */}
        <div className="column">
          <section className="content">
            {type == 0 || type == 2 ? (
              <SimpleContent
                title={content.title}
                body={(content as SimpleContent).body}
                footNote={(content as SimpleContent).footNote}
                hasMoreInfo={(content as SimpleContent).hasMoreInfo}
                moreInfoSrc={moreInfoSrc}
              />
            ) : (
              <BioContent
                title={content.title}
                body={(content as SimpleContent).body}
                footNote={(content as SimpleContent).footNote}
                hasMoreInfo={(content as SimpleContent).hasMoreInfo}
              />
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default TileSection;
